<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('MWCC000168')"
					:inputValue="mstCd"
					:options="taskCommCdMstOptions"
					:onChange="value => onChangeSearchParam({ key: 'mstCd', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('MWCC000169')"
					:inputValue="mstCdName"
					:onChange="value => onChangeSearchParam_({ key: 'mstCdName', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('MWCC000145')"
					:inputValue="useYn"
					:options="useYnOptions"
					:onChange="value => onChangeSearchParam({ key: 'useYn', value })"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="search">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>

<script>
import { serviceMethods, serviceComputed } from '@/views/cc/CommonCode/store/helpers';
import { serviceTaskMethods, serviceTaskComputed } from '@/views/qms/TaskCommCd/store/helpers';
import { rootComputed } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.$sf_toggleLoading(true);
		Promise.all([this.searchCommCd_({ commCdType: 'USE_YN', init: [] }), this.searchCommCdTypeOptions_()])
			.then(([r]) => {
				this.setUseYnOptions_(r);
			})
			.finally(() => this.$sf_toggleLoading(false));
	},
	methods: {
		...serviceMethods,
		...serviceTaskMethods,
		onChangeSearchParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeSearchParam_(payload).finally(() => this.$sf_toggleLoading(false));
		},
		search() {
			this.$sf_toggleLoading(true);
			this.searchTaskCommCdMst_({ ...this.taskCommCdMstPagingInfo, currentPage: 1 }).finally(() => this.$sf_toggleLoading(false));
		}
	},
	computed: {
		...serviceComputed,
		...serviceTaskComputed,
		...rootComputed,
		mstCd: {
			get() {
				return this.searchParam.mstCd;
			},
			set(v) {
				this.searchParam.mstCd = v;
			}
		},
		mstCdName: {
			get() {
				return this.searchParam.mstCdName;
			},
			set(v) {
				this.searchParam.mstCdName = v;
			}
		},
		useYn: {
			get() {
				return this.searchParam.useYn;
			},
			set(v) {
				this.searchParam.useYn = v;
			}
		}
	}
};
</script>
